import PropTypes from 'prop-types';
import React, { useContext } from "react";
import { useTranslation } from 'react-i18next';
import ProtocolContext from '../../../containers/Protocols/ProtocolContext/ProtocolContext';
import { patientInProtocolStatus, visitStage, visitStatus, visitTypes } from "../../../variables/Enums";
import { WithAuth } from "../../Authorization/WithAuthProtocol";
import Card from "../../Cards/Card";
import { Audit, Back, Drug, Export, Publish, Remove, Save, Warning, Swap } from "../../Icons/Icons";


export const FormActions = (props) => {
    const {
        onBack,
        onSave,
        onSaveUpload,
        onAuditTrail,
        onScreenFailure,
        onLostToFollowUp,
        onWithoutDrugs,
        onReturnDrugs,
        onDiscontinuation,
        onRemove,
        onExport,
        visit,
        onEndPatientInProtocol,
        onRollbackVisitStatus,
        protocolId,
        isSubmitting,
        disabled,
        hasMissingConsents,
        onChangeType
    } = props;

  const { t } = useTranslation();
  const context = useContext(ProtocolContext);

  if (!visit)
    return null;

    return (
        <Card
            title={t('medicalRecords.actions')}
            className="card-actions"
            content={
                <>
                    <WithAuth protocolId={protocolId} requiredPermission={["VisitTracking.UploadFile"]}>
                        {   // Subir Adjunto.                            
                            <button
                                type="button"
                                className="btn btn-primary btn-full "
                                onClick={onSaveUpload}
                                disabled={isSubmitting || context.isDisabled || disabled || hasMissingConsents}
                            >
                                <Save style={{ marginRight: '5px' }} />{t('protocols.visitTracking.saveUploadChanges')}
                            </button>
                        }
                    </WithAuth>
                    <WithAuth protocolId={protocolId} requiredPermission={["VisitTracking.Add"]}>
                        <button
                            type="button"
                            disabled={isSubmitting || context.isDisabled || disabled}
                            className="btn btn-primary btn-full "
                            onClick={() => onSave()}
                        >
                            <Save style={{ marginRight: '5px' }} />{t('protocols.visitTracking.saveChanges')}
                        </button>
                    </WithAuth>
                    <WithAuth protocolId={protocolId} requiredPermission={["VisitTracking.ExportPatientVisit"]}>
                        <button
                            type="button"
                            className="btn btn-success btn-full "
                            onClick={onExport}
                            disabled={isSubmitting || context.isDisabled || disabled}
                        >
                            <Export style={{ marginRight: '5px' }} />{t('protocols.visitTracking.export')}
                        </button>
                    </WithAuth>
                    <WithAuth protocolId={protocolId} requiredPermission={["VisitTracking.Publish"]}>
                        {   // Publicación de Visita.
                            (visit.type !== visitTypes.EarlyCompletion &&
                                visit.status !== visitStatus.Failed && visit.status !== visitStatus.Skipped && visit.status !== visitStatus.Completed) &&
                            <button
                                    disabled={isSubmitting || context.isDisabled || disabled || hasMissingConsents}
                                type="submit"
                                className="btn btn-success btn-full"
                            >
                                <Publish style={{ marginRight: '5px' }} />
                                {visit.status === visitStatus.Changed && t('protocols.visitTracking.publishChanges')}
                                {visit.status !== visitStatus.Changed && t('protocols.visitTracking.publish')}
                            </button>
                        }
                        { // Eliminar visita. 
                            (
                                (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted)
                            ) &&
                            <button
                                type="button"
                                name="remove"
                                className="btn btn-danger btn-full"
                                onClick={() => onRemove()}
                                disabled={isSubmitting || context.isDisabled || disabled}
                            >
                                <Remove style={{ marginRight: '5px' }} />{t('protocols.visitTracking.remove')}
                            </button>
                        }
                        {
                            // Terminar participación del paciente en el protocolo
                            (
                                (
                                    props.patientInProtocolStatus === patientInProtocolStatus.Random ||
                                    props.patientInProtocolStatus === patientInProtocolStatus.Treatment ||
                                    props.patientInProtocolStatus === patientInProtocolStatus.FollowUp ||
                                    props.patientInProtocolStatus === patientInProtocolStatus.WithoutDrugs
                                ) &&
                                (visit.status === visitStatus.Completed || visit.status === visitStatus.Changed)
                            ) &&
                            <button
                                type="button"
                                className="btn btn-warning btn-full "
                                onClick={onEndPatientInProtocol}
                                disabled={isSubmitting || context.isDisabled || disabled}
                            >
                                <Warning style={{ marginRight: '5px' }} />{t('protocols.visitTracking.endPatientInProtocol')}
                            </button>
                        }
                        {
                            // Sin Medicacion
                            (
                                (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted) &&
                                (
                                    props.patientInProtocolStatus === patientInProtocolStatus.Random ||
                                    props.patientInProtocolStatus === patientInProtocolStatus.Treatment
                                )
                                &&
                                (
                                    props.patientInProtocolStatus !== patientInProtocolStatus.WithoutDrugs
                                )
                            ) &&
                            <button
                                type="button"
                                className="btn btn-info btn-full "
                                onClick={onWithoutDrugs}
                                disabled={isSubmitting || context.isDisabled || disabled}
                            >
                                <Drug style={{ marginRight: '5px' }} />{t('protocols.visitTracking.withoutDrugs')}
                            </button>
                        }
                        { // Retornar Medicacion
                            (
                                (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted) &&
                                (
                                    //props.patientInProtocolStatus === patientInProtocolStatus.Random ||
                                    //props.patientInProtocolStatus === patientInProtocolStatus.Treatment ||
                                    props.patientInProtocolStatus === patientInProtocolStatus.WithoutDrugs
                                )
                            ) &&
                            <button
                                type="button"
                                className="btn btn-info btn-full "
                                onClick={onReturnDrugs}
                                disabled={isSubmitting || context.isDisabled || disabled}
                            >
                                <Drug style={{ marginRight: '5px' }} />{t('protocols.visitTracking.returnDrugs')}
                            </button>
                        }
                        { // Cambiar tipo (Presencial/Telefónica)
                            ((visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted)) &&
                            <button
                                type="button"
                                className={`btn btn-primary btn-fill btn-full`}
                                onClick={onChangeType}
                                disabled={isSubmitting || context.isDisabled || disabled}>
                                <Swap /> {t('buttons.changeType')}
                            </button>
                        }
                        { // Rollback Visit Status
                            (visit.status === visitStatus.Skipped ||
                                (
                                    props.patientInProtocolStatus === patientInProtocolStatus.Failed ||
                                    props.patientInProtocolStatus === patientInProtocolStatus.LostToFollowUp ||
                                    props.patientInProtocolStatus === patientInProtocolStatus.Discontinuation ||
                                    props.patientInProtocolStatus === patientInProtocolStatus.EndParticipationInProtocol
                                )) &&
                            <button
                                type="button"
                                className="btn btn-info btn-full "
                                onClick={onRollbackVisitStatus}
                                disabled={isSubmitting || context.isDisabled || disabled}
                            >
                                <Warning style={{ marginRight: '5px' }} />{t('protocols.visitTracking.rollbackStatus')}
                            </button>
                        }
                        { // Discontinuacion
                            (visit.status !== visitStatus.Failed && visit.status !== visitStatus.Skipped && props.patientInProtocolStatus >= patientInProtocolStatus.Random) &&
                            <button
                                type="button"
                                className="btn btn-danger btn-full"
                                onClick={onDiscontinuation}
                                disabled={isSubmitting || context.isDisabled || disabled}
                            >
                                <Warning style={{ marginRight: '5px' }} />{t('protocols.visitTracking.discontinuation')}
                            </button>
                        }
                        {   // Falla Seguimiento (Random, Treatment, FollowUp)
                            (
                                (
                                    (props.patientInProtocolStatus == patientInProtocolStatus.Random) ||
                                    (props.patientInProtocolStatus == patientInProtocolStatus.Treatment) ||
                                    (props.patientInProtocolStatus == patientInProtocolStatus.FollowUp) ||
                                    (props.patientInProtocolStatus === patientInProtocolStatus.WithoutDrugs)
                                )
                                &&
                                (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted)
                            ) &&
                            <button
                                type="button"
                                className="btn btn-danger btn-full "
                                onClick={onLostToFollowUp}
                                disabled={isSubmitting || context.isDisabled || disabled}
                            >
                                <Warning style={{ marginRight: '5px' }} />{t('protocols.visitTracking.lostToFollowUp')}
                            </button>
                        }
                        {   // Falla de Screening.
                            (props.patientInProtocolStatus < patientInProtocolStatus.Random) &&
                            visit.type !== visitTypes.EarlyCompletion &&
                            <button
                                type="button"
                                className="btn btn-danger btn-full"
                                onClick={onScreenFailure}
                                disabled={isSubmitting || context.isDisabled || disabled}
                            >
                                <Warning style={{ marginRight: '5px' }} />{t('protocols.visitTracking.screenFailure')}
                            </button>
                        }
                    </WithAuth>
                    <WithAuth protocolId={protocolId} requiredPermission={["VisitTracking.View"]}>
                        <button className={`btn btn-default btn-fill btn-full`} onClick={onBack}>
                            <Back /> {t('buttons.back')}
                        </button>
                    </WithAuth>
                    <button className={`btn btn-default btn-fill btn-full`} onClick={props.onBackToMR}>
                        <Back /> {t('protocols.visitTracking.viewMR')}
                    </button>
                    <button
                        type="button"
                        className="btn btn-audit btn-fill btn-full"
                        onClick={() => onAuditTrail()}
                    >
                        <Audit style={{ marginRight: '5px' }} />{t('protocols.visitTracking.auditTrail')}
                    </button>
                </>
            }
        />
    );
}

FormActions.propTypes = {
  onBack: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onAuditTrail: PropTypes.func.isRequired,
  onScreenFailure: PropTypes.func.isRequired,
  visit: PropTypes.object,
  protocolId: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};
